import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { donorKeys } from '../queries/keys';
import { donorPaths } from '../queries/paths';

// TSS vite/03 — aggregate KPI hook for cowhousing ("cómo rinde mi lote").
// Endpoint REAL (contract: public-client-channel.md, GET public/stats?view=kpi).
// public/stats es COMPARTIDO (parcería + cowhousing + informe); acá solo se
// consume el bloque donors_kpi. El caller lee envelope.data.donors_kpi y
// valida envelope.available_modules.includes('donors_kpi') — el módulo solo
// aparece cuando el rol donor_owner del token tiene datos (MODULE_ROLE).
//
// Ojo: donors_kpi.rates es un SUBCONJUNTO {viability, fertilization,
// pregnancy, survival} — sin transfer ni embryonic_loss (kpi-catalog G3).

export function useClientDonorsKpi() {
    return useQuery({
        queryKey: donorKeys.kpi(),
        queryFn: ({ signal }) =>
            api.get(donorPaths.stats(), { params: { view: 'kpi' }, signal }).then(r => r.data),
    });
}
